import { RouteType } from "../../../types/RouteType";

const BatchTicketGenerationWorkflowRoute: RouteType = {
  name: "Batch Ticket Generation",
  path: "/workflows/batch-ticket-generation",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./BatchTicketGenerationWorkflowHeader"),
      title: "Generate Batch Ticket",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./BatchTicketGenerationWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default BatchTicketGenerationWorkflowRoute;
